import { createFileRoute } from '@tanstack/react-router'
import { UserEditor } from './-UserEditor'

export const Route = createFileRoute('/settings/users/$id')({
  component: UserDetailPage,
})

function UserDetailPage() {
  const { id } = Route.useParams()
  return <UserEditor id={id} />
}
